import { ExitingPersistence } from '@atlaskit/motion';
import React, { useCallback, useEffect, useState } from 'react';
import { useScrollLock } from '../../useScrollLock';
import { useIsMobile } from '../useIsMobile';
import { MobileFilterDialog } from './MobileFilterDialog';
import { ShowFiltersButton } from './ShowFiltersButton';
export const MobileFilters = _ref => {
  let {
    filterDefinitions,
    filterOptions,
    selectedOptions,
    filterStatus,
    sortOptions,
    selectedSortOption,
    onSelectedOptionsChange,
    onSelectedSortOptionChange,
    onClearAllFilters,
    onApplyFilters,
    onCloseMobileDialog
  } = _ref;
  const isMobile = useIsMobile();
  const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);
  useEffect(() => {
    if (!isMobile) {
      setIsFilterDialogOpen(false);
    }
  }, [isMobile]);
  useScrollLock(isFilterDialogOpen);
  const handleShowFiltersClicked = useCallback(() => {
    setIsFilterDialogOpen(true);
  }, []);
  const handleCloseDialog = useCallback(() => {
    setIsFilterDialogOpen(false);
    onCloseMobileDialog === null || onCloseMobileDialog === void 0 ? void 0 : onCloseMobileDialog();
  }, [onCloseMobileDialog]);
  const handleApplyFiltersClick = useCallback(() => {
    onApplyFilters === null || onApplyFilters === void 0 ? void 0 : onApplyFilters();
    setIsFilterDialogOpen(false);
  }, [onApplyFilters]);
  const numberOfSelections = Object.values(selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : {}).reduce((acc, options) => acc + options.length, 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ShowFiltersButton, {
    enableSort: sortOptions.length > 0,
    numberOfSelections: numberOfSelections,
    onClick: handleShowFiltersClicked
  }), /*#__PURE__*/React.createElement(ExitingPersistence, {
    appear: true
  }, isFilterDialogOpen && /*#__PURE__*/React.createElement(MobileFilterDialog, {
    filterDefinitions: filterDefinitions,
    filterOptions: filterOptions,
    selectedOptions: selectedOptions,
    sortOptions: sortOptions,
    selectedSortOption: selectedSortOption,
    filterStatus: filterStatus,
    onClose: handleCloseDialog,
    onSelectedOptionsChange: onSelectedOptionsChange,
    onSelectedSortOptionChange: onSelectedSortOptionChange,
    onClearAllFilters: onClearAllFilters,
    onApplyFilters: handleApplyFiltersClick
  })));
};